import $ from 'jquery';
import GLightbox from 'glightbox';
import {quantityInput, phoneInputMask} from '../form/inputs'
import { setCookie, getCookie } from '../helpers'

import select2 from 'select2/dist/js/select2'
import validateDefaults from "../validateDefaults";

require('slick-carousel/slick/slick.min')

const $body = $('body');
const _token = $('meta[name="csrf-token"]').attr('content');

const copyLink = () => {
    const copy__link = $('.copy__link');
    const copy__link_alert = $('.copy__link_alert');


    let $temp = $("<input>");
    let $url = $(location).attr('href');

    copy__link.on('click', function (e) {
        e.preventDefault();
        $body.append($temp);
        $temp.val($url).select();
        document.execCommand("copy");
        $temp.remove();
        copy__link_alert.fadeIn(300);
        setTimeout(function () {
            copy__link_alert.fadeOut(300);
        }, 1500);

    })
};


const productSlider = () => {

        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: '.slider-nav',
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        dots: true,
                    }
                },
            ]
        });

        $('.slider-nav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.slider-for',
            infinite: false,
            focusOnSelect: true
        });



    const product__lightbox = GLightbox({
        selector: '.open__image'
    });

    const product__material = GLightbox({
        selector: '.open__material'
    });

    const product__material_spec = GLightbox({
        selector: '.open__material_spec'
    });

}

const productSelectDelivery = () => {

    $('.select-trigger').select2({
        dropdownParent: $('#deliveryModal .modal-body')
    });

    let regionSelected = false;
    let citySelected = false;

    $('[name="delivery__region"]').on('select2:select', function (e) {
        regionSelected = true;
        if ( regionSelected ) {
            $(".product__delivery_result_price").text($('[name="price_zone_'+ (parseInt(e.params.data.element.dataset.zone) + 1)  +'"]').val() + " RON")

            let $citySelect = $('[name="delivery__city"]');
            $citySelect.prop('disabled', true);
            $citySelect.empty().append('<option value="">Alege o opțiune</option>');

            $.ajax({
                url: '/delivery-ro',
                type: 'POST',
                cache: false,
                data: {
                    id: e.params.data.id,
                    _token: _token
                },
                success: function (result) {
                    result.forEach(function (locality) {
                        $citySelect.append(
                            `<option value="${locality.id}">${locality.title}</option>`
                        );
                    });

                    $citySelect.prop('disabled', false);

                    $citySelect.trigger('change');
                    $(".button__delivery_submit").addClass('d-none');
                },
                error: function (xhr, status, error) {
                    console.error('AJAX Error:', status, error);
                }
            });
        }
    });


    $('[name="delivery__city"]').on('select2:select', function (e) {
        citySelected = true;
        if ( regionSelected && citySelected ) {
            $(".button__delivery_submit").removeClass('d-none');

            $(".product__delivery_result_date").each(function( ) {
                $( this ).text($(".delivery_result_date_modal").data('date-delivery'))
            });
        }
    });


    let idCountie = getCookie('id_countie');
    let idLocalitie = getCookie('id_localitie');
    let zonePrice = getCookie('zone_price');
    let deliveryDate = getCookie('delivery_date');
    let localityName = getCookie('locality_name');

    if (idCountie) {
        $('[name="delivery__region"]').val(idCountie).trigger('change'); // Устанавливаем регион
        regionSelected = true;
    }

    if (idCountie) {
        $.ajax({
            url: '/delivery-ro',
            type: 'POST',
            cache: false,
            data: {
                id: idCountie,
                _token: _token
            },
            success: function (localities) {
                let $citySelect = $('[name="delivery__city"]');
                $citySelect.empty().append('<option value="">Alege o opțiune</option>');

                localities.forEach(function (locality) {
                    $citySelect.append(
                        `<option value="${locality.id}">${locality.title}</option>`
                    );
                });

                if (idLocalitie) {
                    $citySelect.val(idLocalitie).trigger('change');
                    citySelected = true;
                }

                if (idCountie && idLocalitie) {
                    $citySelect.prop('disabled', false);
                }
            }
        });
    }

    if (zonePrice) {
        $(".button__delivery").text(localityName);
        $(".product__delivery_result").removeClass("d-none");
        $(".product__delivery_result_date").each(function () {
            $(this).text(deliveryDate);
        });

        const zonePriceAdmin = parseInt($('[name="price_zone_'+ (parseInt($('[name="delivery__region"] option:selected').data('zone')) + 1)  +'"]').val());

        if (parseInt(zonePrice) !== zonePriceAdmin) {
            zonePrice = zonePriceAdmin;
            setCookie('zone_price', zonePrice, {expires: 15552000, path: '/'});
        }

        $(".product__delivery_result_price").text(zonePrice + " RON");
    }

};


jQuery(document).ready(function () {
    quantityInput();
    phoneInputMask();
    copyLink();


    productSlider()

    let siteLocation = $('[name="location"]').val();

    if (siteLocation === "2") {
        productSelectDelivery();
    }

})
